import React from 'react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
}
export function Button({
  children,
  className = '',
  ...props
}: ButtonProps) {
  return <button className={`
        inline-flex items-center justify-center px-8 py-4 
        font-heading font-bold text-lg uppercase tracking-wider 
        text-warm-bg bg-warm-dark rounded-sm
        transition-all duration-300 hover:opacity-80
        focus:outline-none focus:ring-2 focus:ring-warm-dark focus:ring-offset-2 focus:ring-offset-warm-bg
        ${className}
      `} {...props} data-id="element-153">
      <span className="flex items-center gap-2" data-id="element-154">{children}</span>
    </button>;
}